/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface GeneratePayRunRequest
 */
export interface GeneratePayRunRequest {
  /**
   *
   * @type {boolean}
   * @memberof GeneratePayRunRequest
   */
  confirm: boolean;
}

/**
 * Check if a given object implements the GeneratePayRunRequest interface.
 */
export function instanceOfGeneratePayRunRequest(
  value: object,
): value is GeneratePayRunRequest {
  if (!("confirm" in value) || value["confirm"] === undefined) return false;
  return true;
}

export function GeneratePayRunRequestFromJSON(
  json: any,
): GeneratePayRunRequest {
  return GeneratePayRunRequestFromJSONTyped(json, false);
}

export function GeneratePayRunRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GeneratePayRunRequest {
  if (json == null) {
    return json;
  }
  return {
    confirm: json["confirm"],
  };
}

export function GeneratePayRunRequestToJSON(json: any): GeneratePayRunRequest {
  return GeneratePayRunRequestToJSONTyped(json, false);
}

export function GeneratePayRunRequestToJSONTyped(
  value?: GeneratePayRunRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    confirm: value["confirm"],
  };
}
